import { Component, Input, OnDestroy } from '@angular/core';
import { ConsultationFileType } from '@models/consultation-file-type.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { NoteAudioType } from '../../../../models/note-audio-type.enum';

@Component({
  selector: 'app-consult-transcription',
  templateUrl: './consult-transcription.component.html',
  styleUrls: ['./consult-transcription.component.less'],
})
export class ConsultTranscriptionComponent implements OnDestroy {
  @Input() consultationFileType: ConsultationFileType;
  @Input() noteAudioType: NoteAudioType;
  @Input() transcription: string;
  @Input() base64AudioSrc: string;

  private unsub: Subject<any> = new Subject<any>();
  loading = false;

  ConsultationFileType = ConsultationFileType;
  NoteAudioType = NoteAudioType;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
